import { render, staticRenderFns } from "./MealCustomizer.vue?vue&type=template&id=e80a5160&"
import script from "./MealCustomizer.vue?vue&type=script&lang=js&"
export * from "./MealCustomizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports